import { render, staticRenderFns } from "./project-list.vue?vue&type=template&id=31be207f&scoped=true&"
import script from "./project-list.vue?vue&type=script&lang=js&"
export * from "./project-list.vue?vue&type=script&lang=js&"
import style0 from "./project-list.vue?vue&type=style&index=0&id=31be207f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be207f",
  null
  
)

export default component.exports